import CardActions from '@mui/material/CardActions';
import { styled } from '@mui/material/styles';

export default styled(CardActions)(({ theme }) => ({
  boxShadow: `inset 0px 1px 0px ${theme.colors.strokeLight}`,
}));
